import { render } from "./LandingPage.vue?vue&type=template&id=e54bbc3e&ts=true"
import script from "./LandingPage.vue?vue&type=script&lang=ts"
export * from "./LandingPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__